var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner batch_page" }, [
    _c(
      "div",
      {
        staticClass: "app-main-inner-row",
        staticStyle: { "padding-top": "10px" }
      },
      [
        _c(
          "el-form",
          { attrs: { "label-width": "60px", "label-position": "left" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_DataType") } },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "Business", disabled: !this.cbJobEnabled },
                    model: {
                      value: _vm.cbJobSelected,
                      callback: function($$v) {
                        _vm.cbJobSelected = $$v
                      },
                      expression: "cbJobSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Business")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbInvoiceReceivableSelected",
                      disabled: !this.cbInvoiceReceivableEnabled
                    },
                    model: {
                      value: _vm.cbInvoiceReceivableSelected,
                      callback: function($$v) {
                        _vm.cbInvoiceReceivableSelected = $$v
                      },
                      expression: "cbInvoiceReceivableSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ARInvoice")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbInvoicePayableSelected",
                      disabled: !this.cbInvoicePayableEnabled
                    },
                    model: {
                      value: _vm.cbInvoicePayableSelected,
                      callback: function($$v) {
                        _vm.cbInvoicePayableSelected = $$v
                      },
                      expression: "cbInvoicePayableSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_APInvoice")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbBillingReceivableSelected",
                      disabled: !this.cbBillingReceivableEnabled
                    },
                    model: {
                      value: _vm.cbBillingReceivableSelected,
                      callback: function($$v) {
                        _vm.cbBillingReceivableSelected = $$v
                      },
                      expression: "cbBillingReceivableSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ARBill")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbBillingPayableSelected",
                      disabled: !this.cbBillingPayableEnabled
                    },
                    model: {
                      value: _vm.cbBillingPayableSelected,
                      callback: function($$v) {
                        _vm.cbBillingPayableSelected = $$v
                      },
                      expression: "cbBillingPayableSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_APBill")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbBillingOverseaSelected",
                      disabled: !this.cbBillingOverseaEnabled
                    },
                    model: {
                      value: _vm.cbBillingOverseaSelected,
                      callback: function($$v) {
                        _vm.cbBillingOverseaSelected = $$v
                      },
                      expression: "cbBillingOverseaSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InternationalBill")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbReceivableInlandSelected",
                      disabled: !this.cbReceivableInlandEnabled
                    },
                    model: {
                      value: _vm.cbReceivableInlandSelected,
                      callback: function($$v) {
                        _vm.cbReceivableInlandSelected = $$v
                      },
                      expression: "cbReceivableInlandSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DomesticCollection")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbPayableInlandSelected",
                      disabled: !this.cbPayableInlandEnabled
                    },
                    model: {
                      value: _vm.cbPayableInlandSelected,
                      callback: function($$v) {
                        _vm.cbPayableInlandSelected = $$v
                      },
                      expression: "cbPayableInlandSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DomesticPayment")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbReceivableOverseaSelected",
                      disabled: !this.cbReceivableOverseaEnabled
                    },
                    model: {
                      value: _vm.cbReceivableOverseaSelected,
                      callback: function($$v) {
                        _vm.cbReceivableOverseaSelected = $$v
                      },
                      expression: "cbReceivableOverseaSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OverseasCollection")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: {
                      no: "cbPayableOverseaSelected",
                      disabled: !this.cbPayableOverseaEnabled
                    },
                    model: {
                      value: _vm.cbPayableOverseaSelected,
                      callback: function($$v) {
                        _vm.cbPayableOverseaSelected = $$v
                      },
                      expression: "cbPayableOverseaSelected"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OverseasPayment")))]
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "el-form-item-search",
                attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDate") }
              },
              [
                _c(
                  "el-col",
                  { attrs: { span: 9 } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        no: "startDate",
                        type: "date",
                        clearable: false,
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        "picker-options": _vm.pickerOptionsStartDate
                      },
                      model: {
                        value: _vm.startDate,
                        callback: function($$v) {
                          _vm.startDate = $$v
                        },
                        expression: "startDate"
                      }
                    })
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 2 } }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_To")))])
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 9 } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        no: "endDate",
                        type: "date",
                        clearable: "",
                        "value-format": "yyyy-MM-dd",
                        "picker-options": _vm.pickerOptionsEndDate
                      },
                      model: {
                        value: _vm.endDate,
                        callback: function($$v) {
                          _vm.endDate = $$v
                        },
                        expression: "endDate"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticStyle: {
                  "padding-top": "10px",
                  "padding-bottom": "240px"
                }
              },
              [
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "isExport" },
                    model: {
                      value: _vm.isExport,
                      callback: function($$v) {
                        _vm.isExport = $$v
                      },
                      expression: "isExport"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_CreateAndExportDirectly"))
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }